export default __webpack_public_path__ + "static/media/Badge_Placement_Beavers.de5a537b.jpeg";